import AutoSuggestOption from './AutoSuggestOption';
import { AutoSuggestOptionsProps } from './types';

// eslint-disable-next-line
function AutoSuggestOptions<T>(props: AutoSuggestOptionsProps<T>) {
    const {
        id,
        options,
        name,
        selectedOptionId,
        onOptionClick,
    } = props;

    let index = 1;

    return (
        <ul
            id={id}
            role='listbox'
            aria-label='Suggested options'
            // aria-labelledby={`${name}`}
            className='suggestion-options'
        >
            {options && options.map((opt) => (
                <AutoSuggestOption
                    key={opt.id}
                    id={opt.id}
                    selected={selectedOptionId}
                    onClick={onOptionClick}
                    value={opt.value}
                    displayText={opt.displayText}
                    // eslint-disable-next-line no-plusplus
                    ariaLabel={`${opt.displayText} (${index++} of ${options.length})`}
                />
            ))}
        </ul>
    );
}

export default AutoSuggestOptions;
